import { render, staticRenderFns } from "./MyProject.vue?vue&type=template&id=1bd6401c&"
import script from "./MyProject.vue?vue&type=script&lang=js&"
export * from "./MyProject.vue?vue&type=script&lang=js&"
import style1 from "./MyProject.vue?vue&type=style&index=1&id=1bd6401c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd6401c')) {
      api.createRecord('1bd6401c', component.options)
    } else {
      api.reload('1bd6401c', component.options)
    }
    module.hot.accept("./MyProject.vue?vue&type=template&id=1bd6401c&", function () {
      api.rerender('1bd6401c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projects/MyProject.vue"
export default component.exports